"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
                                                                             * Copyright (c) 2018-present, Leap DAO (leapdao.org)
                                                                             *
                                                                             * This source code is licensed under the GNU Affero General Public License,
                                                                             * version 3, found in the LICENSE file in the root directory of this source
                                                                             * tree.
                                                                             */

/* eslint-disable import/prefer-default-export */

/**
                                                   * Number of blocks per Period
                                                   */

var BLOCKS_PER_PERIOD = exports.BLOCKS_PER_PERIOD = 32;